import React, { useEffect } from "react";
import { motion } from "framer-motion";
import step2 from "../../images/turtle-setup.png"; // Replace with actual images
import qrcode from "../../images/algoTurtle-qrcode.png";
const steps = [
  {
    id: "01",
    title: "Download AlgoTurtle App",
    description:
      "Get started by downloading the AlgoTurtle app from the Google Play Store. Scan the QR code or click the download button to install the app and unlock the power of algorithmic trading at your fingertips.",
    jsx: (
      <div className="bg-white rounded-lg shadow-lg text-black w-[260px] text-center  transform transition-transform hover:scale-105 hover:shadow-xl mx-auto">
        <img
          className="qr-code w-full h-auto mb-3 rounded-md"
          src={qrcode}
          alt="QR Code"
        />
        <p className="text-gray-700 font-medium ">OR</p>
        <a
          href="https://play.google.com/store/apps/details?id=com.proalgoturtle"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="download-app m-auto bg-[#2d3191] w-full rounded-b-lg p-2 flex items-center justify-center space-x-3 transition-transform hover:scale-105">
            <img
              className="playstore w-10 h-10 transition-transform hover:scale-110"
              src="/static/media/playstore.481f2ee8d0e78831ddc0.png"
              alt="Play Store"
            />
            <p className="text-white font-semibold hover:underline">Download</p>
          </div>
        </a>
      </div>
    ),
  },
  {
    id: "02",
    title: "Create Account ",
    description:
      "Start your journey by setting up your account. It's quick, secure, and gives you access to all features. Join now and take the first step toward a smarter, streamlined experience.",
    image: step2,
  },
];

export default function SetupSteps() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="relative w-full max-w-5xl mx-auto p-8 space-y-16 m-5">
      {steps.map((step, index) => (
        <motion.div
          key={step.id}
          className={`flex flex-col md:flex-row items-center gap-8 ${
            index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
          }`}
          initial={{ opacity: 0, y: index % 2 === 0 ? 50 : -50 }} // Start below for even, above for odd
          whileInView={{ opacity: 1, y: 0 }} // Animate to visible and in position
          viewport={{ once: true, amount: 0.2 }} // Trigger animation when 20% of the item is in view
          transition={{ duration: 0.8, delay: index * 0.2 }} // Staggered animation
        >
          <motion.div
            initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="w-full md:w-1/2 p-5"
          >
            {/* Conditionally render the JSX or image */}
            {step.jsx ? (
              step.jsx
            ) : (
              <img
                src={step.image}
                alt={step.title}
                className="rounded-xl shadow-lg w-full  "
              />
            )}
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="w-full md:w-1/2 space-y-4"
          >
            <h2 className="text-4xl font-bold" style={{ color: "#2d3191" }}>
              {step.id}
            </h2>
            <h3 className="text-2xl font-semibold" style={{ color: "#2d3191" }}>
              {step.title}
            </h3>
            <p className="text-gray-600" style={{ color: "green" }}>
              {step.description}
            </p>
            {/* Conditionally render the anchor element for index 1 */}
            {index === 1 && (
              <a
                href="/setup-guide"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block text-blue-700 font-semibold underline transition-transform transform hover:scale-105"
              >
                Account Setup Guide
              </a>
            )}
          </motion.div>
        </motion.div>
      ))}
      {/* Dotted Vertical Connector Line */}
      <div
        className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1 h-full hidden md:block "
        style={{ marginBottom: "5px" }} // Adds a 5px bottom margin
      >
        <div
          className="h-full w-0.5 border-l-2 border-dotted"
          style={{ borderColor: "#2d3191" }}
        ></div>
      </div>
    </div>
  );
}
